export default __webpack_public_path__ + "static/media/Marla_Isackson_AHV_In_Moms_We_Trust.10b72997.jpg";